// Data only: no CSS, URLs, arbitrary paths, or downloaded fonts.
const contract = require('./appearance-contract.json');
const scopes = ['all', 'ios', 'android', 'web', 'desktop'];
const own = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
const record = (value) => !!value && typeof value === 'object' && !Array.isArray(value);
function validateAppearance(value) {
  const errors = [];
  if (value === null) return { errors, warnings: [] };
  if (!record(value) || value.version !== contract.version) return { errors: ['Unsupported appearance version.'], warnings: [] };
  if (JSON.stringify(value).length > 100000) return { errors: ['Appearance is too large.'], warnings: [] };
  for (const [scope, modes] of Object.entries(value)) {
    if (scope === 'version') continue;
    if (!scopes.includes(scope) || !record(modes)) { errors.push('Unknown appearance platform.'); continue; }
    for (const [mode, tokens] of Object.entries(modes)) {
      if (!['light', 'dark'].includes(mode) || !record(tokens)) { errors.push('Unknown appearance mode.'); continue; }
      for (const [path, token] of Object.entries(tokens)) {
        const field = own(contract.fields, path) && contract.fields[path];
        if (!field) { errors.push('Unknown appearance control.'); continue; }
        const valid = field.type === 'color' ? typeof token === 'string' && /^#[0-9a-f]{6}$/i.test(token)
          : field.type === 'choice' ? field.options.includes(token)
          : typeof token === 'number' && Number.isFinite(token) && token >= field.min && token <= field.max;
        if (!valid) errors.push(`${scope} / ${mode} / ${field.label}: ${field.type === 'color' ? 'use a six-digit hex color' : field.type === 'choice' ? 'choose an available option' : `use a number from ${field.min} to ${field.max}`}.`);
      }
    }
  }
  return { errors, warnings: [] };
}
module.exports = { validateAppearance };
